import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../../core/shared/service/crud/mvs-crud.service';

/**
 * AI:
 * Status: 'implemented'
 * Type: Service
 * SubType: CRUD Entity Service
 * Reason: CRUD for {@code dq.DqAuditGroup} over {@code /mvsa/dq/auditGroups}.
 *
 * On top of the generic CRUD it carries the object labels and the object icon under which the group
 * appears in generic dialogs, search results and object headers.
 *
 * The route segment is a STRING LITERAL from the backend controller's {@code @RequestMapping} and is
 * derived from nothing — neither from the entity name nor from the alias. It is written out
 * verbatim here and must NEVER be assembled.
 */
@Injectable({providedIn: 'root'})
export class DqAuditGroupService extends MvsCrudService {

    constructor(protected override http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/dq/auditGroups');
    }

    override getObjectIcon(): string {
        return 'fa-solid fa-layer-group';
    }

    override getObjectLabels(): string[] {
        return ['Prüfgruppe', 'Prüfgruppen'];
    }
}
